import { PRODUCTS_NO_ACTION } from "../../../../../../../constants/productActionTypes.js";
import { AnyObject } from "final-form";
import * as EmailValidator from "email-validator";

export const validation = (values) => {
  const errors: AnyObject = {};
  console.log('for some reason we are here!!')

  // Out of Stock Validation
  if (
    values.outStockAction !== PRODUCTS_NO_ACTION ||
    values.outStockNotify.isActive
  ) {
    if (!values.outStockLevel || Number(values.outStockLevel) < 1) {
      errors.outStockLevel = "Minimum value 1";
    }
  }

  // Low Stock Validation
  if (
    values.lowStockAction !== PRODUCTS_NO_ACTION ||
    values.lowStockNotify.isActive
  ) {
    if (!values.lowStockLevelFrom || Number(values.lowStockLevelFrom) < 0) {
      errors.lowStockLevelFrom = "Minimum value 0";
    }

    if (!values.lowStockLevelTo || Number(values.lowStockLevelTo) < 0) {
      errors.lowStockLevelTo = "Minimum value 0";
    }

    if (Number(values.lowStockLevelTo) < Number(values.lowStockLevelFrom)) {
      errors.lowStockLevelFrom = "The 'To' value cannot be less than the 'From' value";
      errors.lowStockLevelTo = "The 'To' value cannot be less than the 'From' value";
    }

    if (
      (values.outStockAction !== PRODUCTS_NO_ACTION &&
        Number(values.lowStockLevelFrom) < Number(values.outStockLevel)) ||
      (values.outStockAction === PRODUCTS_NO_ACTION &&
        values.outStockNotify.isActive &&
        Number(values.lowStockLevelFrom) < Number(values.outStockLevel))
    ) {
      errors.lowStockLevelFrom = "Your Low Stock range cannot be less than your Out of stock range.";
    }
  }

  // Back in Stock Validation
  if (
    values.backStockAction !== PRODUCTS_NO_ACTION ||
    values.backStockNotify.isActive
  ) {
    if (!values.backStockLevel || Number(values.backStockLevel) < 0) {
      errors.backStockLevel = "Minimum value 0";
    }

    if (
      (values.outStockAction !== PRODUCTS_NO_ACTION &&
        Number(values.backStockLevel) + 1 < Number(values.outStockLevel)) ||
      (values.outStockAction === PRODUCTS_NO_ACTION &&
        values.outStockNotify.isActive &&
        Number(values.backStockLevel) + 1 < Number(values.outStockLevel))
    ) {
      errors.backStockLevel = "Your Back in Stock level should be higher than your Out of Stock level.";
    }

    if (
      (values.lowStockAction !== PRODUCTS_NO_ACTION &&
        Number(values.backStockLevel) + 1 < Number(values.lowStockLevelTo)) ||
      (values.lowStockAction === PRODUCTS_NO_ACTION &&
        values.lowStockNotify.isActive &&
        Number(values.backStockLevel) + 1 < Number(values.lowStockLevelTo))
    ) {
      errors.backStockLevel = "Your Back in Stock level should be higher than your Low Stock level.";
    }
  }

  // Email Validation
  if (values.outStockNotify.isActive && !EmailValidator.validate(values.outStockNotify.email)) {
    errors.outStockNotify = "Email is not valid";
  }

  if (values.lowStockNotify.isActive && !EmailValidator.validate(values.lowStockNotify.email)) {
    errors.lowStockNotify = "Email is not valid";
  }

  if (values.backStockNotify.isActive && !EmailValidator.validate(values.backStockNotify.email)) {
    errors.backStockNotify = "Email is not valid";
  }

  return errors;
};